import {autoPluralize} from './pluralizer';


export function entity_item_stats(stats){
    let stats_string = '';
    if(stats && (stats.profile_freq || stats.global_freq)) {
        let fragments = [];
        if (stats.profile_freq) {
            fragments.push(stats.profile_freq);
        }
        if (stats.global_freq) {
            fragments.push(stats.global_freq);
        }
        stats_string = ` (${fragments.join(' / ')})`;
    }
    return stats_string;
}

export function entity_item_stats_info(stats){
    let stats_info = '';
    if(stats && (stats.profile_freq && stats.global_freq)) {
        stats_info = `This value occurs ${autoPluralize(stats.profile_freq, 'time')} in this profile and ${autoPluralize(stats.global_freq, 'time')} in the full data set.`;
    }
    return stats_info;
}
